import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vat-tu-table__footer-label"
}
const _hoisted_2 = {
  key: 1,
  class: "table-index-cell"
}
const _hoisted_3 = { class: "table-index-cell__order" }
const _hoisted_4 = {
  key: 0,
  class: "table-index-cell__id"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0 justify-center" }, "ĐVT", -1)
const _hoisted_6 = { class: "d-flex align-items-center mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_WordBreakColumn = _resolveComponent("WordBreakColumn")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_table, {
    id: _ctx.tableId,
    border: true,
    "cell-class-name": _ctx.cellClassName,
    class: _normalizeClass(['vat-tu-table', _ctx.tableClass]),
    data: _ctx.items,
    "empty-text": _ctx.emptyText,
    "max-height": _ctx.maxHeight,
    "row-class-name": _ctx.rowClassName,
    "show-summary": _ctx.showSummary,
    "span-method": _ctx.spanMethod,
    "summary-method": _ctx.summaryMethod,
    size: "medium"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        "header-align": "center",
        label: "STT",
        prop: "stt",
        width: _ctx.columnWidths.stt
      }, {
        default: _withCtx((scope) => [
          (_ctx.isFooterRow(scope.row))
            ? (_openBlock(), _createElementBlock("strong", _hoisted_1, _toDisplayString(scope.row._footerLabel), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.sttDisplay(scope.$index)), 1),
                (_ctx.showSttId)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (" + _toDisplayString(scope.row.id) + ") ", 1))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _: 1
      }, 8, ["width"]),
      _createVNode(_component_WordBreakColumn, {
        "max-width": _ctx.tenMaxWidth != null ? String(_ctx.tenMaxWidth) : undefined,
        "min-width": String(_ctx.tenMinWidth ?? _ctx.columnWidths.ten),
        width: _ctx.tenWidth != null ? String(_ctx.tenWidth) : undefined,
        "header-title": "Tên",
        property: "ten_vat_tu"
      }, null, 8, ["max-width", "min-width", "width"]),
      _createVNode(_component_WordBreakColumn, {
        width: String(_ctx.columnWidths.ma),
        "header-title": "Mã",
        property: "ma_vat_tu"
      }, null, 8, ["width"]),
      _createVNode(_component_el_table_column, {
        width: _ctx.columnWidths.dvt,
        prop: "don_vi_tinh"
      }, {
        header: _withCtx(() => [
          _hoisted_5
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("p", _hoisted_6, _toDisplayString(scope.row.don_vi_tinh ? scope.row.don_vi_tinh : "-"), 1)
        ]),
        _: 1
      }, 8, ["width"]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["id", "cell-class-name", "class", "data", "empty-text", "max-height", "row-class-name", "show-summary", "span-method", "summary-method"])), [
    [_directive_loading, _ctx.isLoading]
  ])
}